import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Eye, EyeOff } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { useToast } from '../hooks/use-toast';

const ADMIN_PASSWORD = 'hngt1111bela';
const AUTH_KEY = 'hngt_admin_auth';

const AdminLogin = ({ onAuthenticated }) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if already authenticated
    const savedAuth = localStorage.getItem(AUTH_KEY);
    if (savedAuth === ADMIN_PASSWORD) {
      onAuthenticated();
    }
  }, [onAuthenticated]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Simulate a small delay for security appearance
    setTimeout(() => {
      if (password === ADMIN_PASSWORD) {
        localStorage.setItem(AUTH_KEY, ADMIN_PASSWORD);
        toast({
          title: "Acesso concedido",
          description: "Bem-vindo ao painel admin!",
        });
        onAuthenticated();
      } else {
        toast({
          title: "Senha incorreta",
          description: "A senha fornecida está incorreta.",
          variant: "destructive",
        });
        setPassword('');
      }
      setIsLoading(false);
    }, 500);
  };

  const handleBackToSite = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <Card className="bg-[#1A1A1A] border-[#2A2A2A] w-full max-w-md">
        <CardHeader className="text-center">
          <div className="w-16 h-16 bg-[#7C3AED]/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock className="w-8 h-8 text-[#7C3AED]" />
          </div>
          <CardTitle className="text-2xl text-[#E5E5E5]">Painel Admin</CardTitle>
          <CardDescription className="text-[#6B7280]">
            Digite a senha para acessar o painel administrativo
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="relative">
              <Input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Senha de acesso"
                className="bg-[#0A0A0A] border-[#2A2A2A] text-[#E5E5E5] pr-10"
                required
                disabled={isLoading}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#6B7280] hover:text-[#E5E5E5]"
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
            <Button
              type="submit"
              className="w-full bg-[#7C3AED] hover:bg-[#6D28D9]"
              disabled={isLoading}
            >
              {isLoading ? 'Verificando...' : 'Acessar Painel'}
            </Button>
            <Button
              type="button"
              onClick={handleBackToSite}
              variant="outline"
              className="w-full border-[#2A2A2A] text-[#E5E5E5] hover:bg-[#2A2A2A]"
            >
              Voltar ao Site
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;